import useIntlMessage from '@pe-libs/react-components/build/lib/intl/hooks/useIntlMessage';
import messages from './messages';

type MessageType = ReturnType<typeof useIntlMessage>;

export const getSourcesText = (
  formatMessage: MessageType,
  sources: number,
  externalRatingServicesCount: number,
  totalReviewCount: number,
) => {
  if (externalRatingServicesCount === 0 && totalReviewCount === 0) {
    return null;
  }

  switch (true) {
    case externalRatingServicesCount > 0 && totalReviewCount > 0: {
      return formatMessage(messages.sources, { sources });
    }

    case externalRatingServicesCount === 0 && totalReviewCount > 0: {
      return null;
    }

    case externalRatingServicesCount === 1 && totalReviewCount === 0: {
      return formatMessage(messages.singleExternalSource, { externalRatingServicesCount });
    }

    case externalRatingServicesCount > 1 && totalReviewCount === 0: {
      return formatMessage(messages.onlyExternalSources, { externalRatingServicesCount });
    }

    default: {
      return formatMessage(messages.sources, { sources });
    }
  }
};
